const GOOGLE_IDENTITY_SCRIPT_ID = "miridar-google-identity-services";
const GOOGLE_IDENTITY_SCRIPT_SRC = "https://accounts.google.com/gsi/client";

let scriptPromise = null;

export const loadGoogleIdentityServices = () => {
  if (globalThis?.google?.accounts?.id) return Promise.resolve(globalThis.google.accounts.id);
  if (scriptPromise) return scriptPromise;

  scriptPromise = new Promise((resolve, reject) => {
    const existing = document.getElementById(GOOGLE_IDENTITY_SCRIPT_ID);
    const script = existing || document.createElement("script");
    const onLoad = () => {
      const api = globalThis?.google?.accounts?.id;
      if (api) resolve(api);
      else reject(new Error("Google Identity Services did not initialize"));
    };
    const onError = () => {
      scriptPromise = null;
      if (script.parentNode) script.parentNode.removeChild(script);
      reject(new Error("Google Identity Services could not be loaded"));
    };
    script.addEventListener("load", onLoad, { once: true });
    script.addEventListener("error", onError, { once: true });
    if (!existing) {
      script.id = GOOGLE_IDENTITY_SCRIPT_ID;
      script.src = GOOGLE_IDENTITY_SCRIPT_SRC;
      script.async = true;
      script.defer = true;
      document.head.append(script);
    }
  });
  return scriptPromise;
};

export { GOOGLE_IDENTITY_SCRIPT_ID, GOOGLE_IDENTITY_SCRIPT_SRC };
